import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import styled from 'styled-components';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
//backdropFilter: 'blur(6px)'

const StyledDialog = styled(Dialog)`
  @media screen and (max-width: 768px) {
    display: none;
  }

`;
const Modal = ({open, handleClose, children, maxWidth, fullWidth}) => {

  return (
      <StyledDialog
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{borderRadius: 0}}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        {children}
      </StyledDialog>
  );
}

export default Modal;